import { render, staticRenderFns } from "./ClientPPPRoundCard.vue?vue&type=template&id=5497370a&scoped=true&"
import script from "./ClientPPPRoundCard.vue?vue&type=script&lang=js&"
export * from "./ClientPPPRoundCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497370a",
  null
  
)

export default component.exports